import { CollectionsApi } from '@sportheroes/oly-engine-api';

import { olyEngineApi } from './Config/olyEngineApi';

const { CONTENT_API_URL } = process.env;

export default new CollectionsApi(CONTENT_API_URL, {}, olyEngineApi);
